import camelCaseCSS from "camelcase-css";

export const cssParser = (cssString, options) => {
    try {
        const styles = cssString?.replaceAll("\n", "").split(";");
        const cssObject = {};
        styles?.forEach(style => {
            cssObject[camelCaseCSS(style.split(":")[0]?.replaceAll(" ", ""))] = style.split(":")[1];
        });
        const mandatoryStyles = options?.mandatoryStyles;
        if (mandatoryStyles) {
            Object.keys(mandatoryStyles).forEach(styleKey => cssObject[styleKey] = mandatoryStyles[styleKey])
        }
        return cssObject;
    } catch (e) {
        console.error(e);
        return undefined
    }
}